import { emailRegex } from "@/configuration/formConfigurations";
import POIStep from "@/components/POI/POIStep/POIStep.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";

export default {
  name: "BaseData",
  props: [
    "errorList",
    "editedItem",
    "step",
    "position",
    "onOpen",
    "categories",
    "categoryGroups",
    "categoryTypes",
    "isOwnedBySubPrincipal"
  ],
  components: { POIStep, TreeViewSelection },
  data: () => ({
    emailRegex,
    snackbar: false,
    snackbarText: ""
  }),
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    updateValue(value) {
      if (Array.isArray(value)) this.editedItem.category = value[0];
      else this.editedItem.category = value;
    }
  },
  computed: {
    moduleTitle() {
      const id = this.editedItem.categoryType;
      const categoryType = this.categoryTypes?.find(ct => ct._id === id);
      return `Stammdaten "${categoryType?.title}"`;
    },
    isRegion() {
      return (
        this.$store.state.currentUser?.principal_id === this.REGION_PRINCIPAL
      );
    },
    disabled() {
      return (
        this.isOwnedBySubPrincipal ||
        (this.isRegion && this.editedItem.permissions !== "admin")
      );
    },
    additionalCategories() {
      return this.$store.state.categoryGroups.filter(
        group =>
          !group.title.includes("Berg- und Skigebiet (Bergsportbericht)") &&
          !group.title.includes("Alpen & Hütten (Bergsportbericht)") &&
          group.categoryType === this.editedItem.categoryType
      );
    }
  }
};
